/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NbActionsTestComponent } from './actions-test/actions-test.component';
import { NbBootstrapTestComponent } from './bootstrap-test/bootstrap-test.component';

import { AuthGuard } from './../app/auth.guard';
import { NbFormsTestComponent } from './forms-test/forms-test.component';
import { NbLayoutComponent } from './layout-main/layout.component';
import { NbUserTestComponent } from './user-test/user-test.component';
import { NbCardTestComponent } from './card-test/card-test.component';
import { AboutComponent } from './about/about.component';
import { DashboardComponent } from './dashboard/dashboard.component';

import {
  NbAuthComponent,
  NbLoginComponent,
  NbRegisterComponent,
  NbLogoutComponent,
  NbRequestPasswordComponent,
  NbResetPasswordComponent,
} from '../framework/auth';

const routes: Routes = [
  {
    path: '',
    component: NbLayoutComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    children: [
      {
        path: '',
        component: DashboardComponent,
      },
      {
        path: 'about',
        loadChildren: './about/about.module#AboutModule' },
      {
        path: '1',
        redirectTo: 'tab2',
        pathMatch: 'full',
      },
      {
        path: 'admin',
        loadChildren: 'app/system-adm/system-adm.module#SystemAdmModule',
        data: { preload: true },
      },
      {
        path: 'suppliers-barcodes',
        loadChildren: 'app/suppliers-barcodes/supplier-barcodes.module#SuppliersBarcodesModule',
        data: { preload: true },
      },
      {
        path: 'bootstrap',
        component: NbBootstrapTestComponent,
      },
      {
        path: 'actions',
        component: NbActionsTestComponent,
      },
      {
        path: 'forms',
        component: NbFormsTestComponent,
      },
      {
        path: 'card',
        component: NbCardTestComponent,
      },
    ],
  },
  // {
  //   path: 'user',
  //   component: NbUserTestComponent,
  // },
  {
    path: 'auth',
    component: NbAuthComponent,
    children: [
      {
        path: '',
        component: NbLoginComponent,
      },
      {
        path: 'login',
        component: NbLoginComponent,
      },
      {
        path: 'register',
        component: NbRegisterComponent,
      },
      {
        path: 'logout',
        component: NbLogoutComponent,
      },
      {
        path: 'request-password',
        component: NbRequestPasswordComponent,
      },
      {
        path: 'reset-password',
        component: NbResetPasswordComponent,
      },
    ],
  },
  {
    path: '**',
    component: NbUserTestComponent,
  },
];


@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, enableTracing: false })],
  exports: [RouterModule],
})
export class AppRoutingModule { }




// WEBPACK FOOTER //
// ./src/app/app.routing.module.ts